import React from 'react';
import { func, string, object } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';
import ComboBox from '@hmhco/combobox/src/ComboBox/ComboBox';
import useStyles from './Input.styles';
import useSearchOrgs from '../../../../hooks/getSearchedOrgs.hook';

export const schoolRenderer = (
  props,
  { name, addressCity, addressStreet, addressZip },
) => (
  <li {...props}>
    <Box>{name || ''}</Box>
    <Box fontWeight="fontWeightLight">
      <FormattedMessage
        id="login.form.org.international.address"
        values={{ addressCity, addressStreet, addressZip }}
      />
    </Box>
  </li>
);

const returnAllOptions = options => options;

const SchoolAssociationField = ({
  selectedSchool,
  handleChange,
  errorMessageId,
}) => {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();
  const { selectOrg, handleSearchChange, loading, orgs } = useSearchOrgs();

  const handleSelectionChange = (event, value) => {
    selectOrg(value);
    handleChange(value);
  };

  return (
    <div className={classes.fieldContainer}>
      <FormattedMessage id="earlyAccess.createUser.label.schoolAssociation">
        {([label]) => (
          <FormattedMessage id="earlyAccess.createUser.placeholder.schoolAssociation">
            {([placeholder]) => (
              <ComboBox
                filterOptions={returnAllOptions}
                autoHighlight
                classes={{ input: classes.input, option: classes.option }}
                required
                placeholder={placeholder}
                dataTestId="schoolAssociationSelect"
                label={label}
                options={orgs}
                getOptionLabel={option => option.name || ''}
                isOptionEqualToValue={(option, value) =>
                  option.name === value.name
                }
                value={selectedSchool}
                handleChange={handleSelectionChange}
                onInputChange={(event, value) => {
                  handleSearchChange(event, value);
                }}
                loading={loading}
                renderOption={schoolRenderer}
                altError={Boolean(errorMessageId)}
                altErrorText={
                  errorMessageId ? formatMessage({ id: errorMessageId }) : ''
                }
              />
            )}
          </FormattedMessage>
        )}
      </FormattedMessage>
    </div>
  );
};

SchoolAssociationField.propTypes = {
  selectedSchool: object,
  handleChange: func.isRequired,
  errorMessageId: string,
};

export default SchoolAssociationField;
